import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import { syncTranslationWithStore } from "react-redux-i18n";

import rootReducer from "./reducers";

const middleware = [thunk];

const saveState = state => {
  try {
    // remove everything from accountData except prefix and mobile
    /* const cleanState = Object.assign({}, state, {
      account: Object.assign({}, state.account, {
        accountData: {
          internationalPrefix: state.account.accountData.internationalPrefix,
          phone: state.account.accountData.phone,
        },
      }),
    }); */

    // Convert the state to a JSON string
    const serialisedState = JSON.stringify(state);

    // Save the serialised state to localStorage against the key 'app_state'
    window.localStorage.setItem("app_state", serialisedState);
  } catch (err) {
    // Log errors here, or ignore
    console.log(err);
  }
};

const loadState = () => {
  try {
    // Load the data saved in localStorage, against the key 'app_state'
    const serialisedState = window.localStorage.getItem("app_state");

    // Passing undefined to createStore will result in our app getting the default state
    // If no data is saved, return undefined
    if (!serialisedState) return undefined;

    // De-serialise the saved state to return it.
    const parsedState = JSON.parse(serialisedState);

    return parsedState;
  } catch (err) {
    // Return undefined if localStorage is not available,
    // or data could not be de-serialised,
    // or there was some other error
    return undefined;
  }
};

const oldState = loadState();

const store = createStore(
  rootReducer,
  oldState,
  composeWithDevTools(applyMiddleware(...middleware))
);

store.subscribe(() => {
  saveState(store.getState());
});

syncTranslationWithStore(store);
export default store;
